<ng-container *ngrxLet="notifications$ as notifications">
  <mat-toolbar color="accent">
    <span>Notifications</span>
    <div fxFlex></div>
    <div>
      <button
        *ngIf="notifications.length"
        mat-icon-button
        (click)="markAllRead(notifications)"
      >
        <mat-icon>done_all</mat-icon>
      </button>
      <button mat-icon-button (click)="closed.next()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div fxLayout="column" fxLayoutGap="16px" class="layout-padding">
    <ng-container *ngIf="notifications.length; else noNotifications">
      <div
        *ngFor="let notification of notifications; trackBy: trackByNotification"
        class="notification"
      >
        <ng-container *ngIf="!notification.viewed">
          <pt-notification
            [notification]="notification"
            [currentUser]="organisation.staffer$ | ngrxPush"
            [preview]="true"
            [extensions]="notificationExtensions"
           />
        </ng-container>
      </div>
    </ng-container>

    <ng-template #noNotifications>
      <div fxLayout="row" fxLayoutAlign="center">
        <small class="no-notifications">No Notifications</small>
      </div>
    </ng-template>

    <a
      *ngIf="organisation.brand$ | ngrxPush as brand"
      class="notifications-link"
      [routerLink]="['/', 'account', 'notifications']"
      (click)="closed.next()"
    >
      See All Notifications
    </a>
  </div>
</ng-container>
